<script lang="ts">
  import TileChart from './TileChart.svelte';
  import TileEditor from './TileEditor.svelte';
  import { tileName, tileView, type Goal, type Tiles } from '../../utils/insights';
  import { t } from '../../i18n/index.ts';

  // TilesSection shows the member's chosen tiles (spec 006 FR-079): each
  // its value, a bar for each of 7 days, and a badge from the goal behind it.
  // onday opens a day in the training log.
  let { tiles, goals, onchange, onday }: { tiles: Tiles; goals: Goal[]; onchange: (t: Tiles) => void; onday: (day: string) => void } = $props();
  let editing = $state(false);
</script>

<section class="space-y-2" aria-labelledby="tiles-heading">
  <div class="flex items-center justify-between">
    <h2 id="tiles-heading" class="font-semibold">{t('activitiesTiles')}</h2>
    <button class="btn btn-secondary btn-sm" onclick={() => (editing = true)}>{t('activitiesTilesEdit')}</button>
  </div>
  <ul class="grid gap-2 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
    {#each tiles.tiles as id (id)}
      {@const v = tileView(id, tiles, goals)}
      <li class="card p-3 space-y-2">
        <p class="text-sm font-medium">{tileName(id)}</p>
        {#if v.noData}
          <p class="text-2xl">{t('activitiesTilesNoData')}</p>
          <p class="text-xs text-text-muted">{t('activitiesTilesNoSteps')}</p>
        {:else}
          <p><span class="text-2xl">{v.value}</span> <span class="text-sm text-text-muted">{v.caption}</span></p>
          <TileChart {id} {v} {onday} />
          {#if v.badge}
            <span class="inline-block text-xs rounded-full px-2 py-0.5" style="background: {v.badge.met ? 'var(--theme-success)' : 'var(--theme-surface1)'}; color: {v.badge.met ? 'var(--theme-base)' : 'var(--theme-text)'};">{v.badge.text}</span>
          {/if}
        {/if}
      </li>
    {/each}
  </ul>
</section>

{#if editing}
  <TileEditor tiles={tiles.tiles} onclose={() => (editing = false)} onsaved={(next) => { editing = false; onchange(next); }} />
{/if}
